import React, { useEffect } from 'react';
import useRequest from '@umijs/use-request';
import { Select } from 'antd';
import PropTypes from 'prop-types';
import request from '../../../utils/request';

/**
 * Un componente select que obtiene sus posibles a traves de una request
 * GET a la url entregada.
 *
 * Si no se entrega ninguna url se comporta como un select normal de Antd
 *
 */
const SelectWithRequest = ({ url, children, addOtherOption, useId, ...selectProps }) => {
  const { data: optionsData, loading } = useRequest(
    async () =>
      request({
        url: encodeURI(url),
        method: 'GET',
      })
        .then((response) => response?.data)
        .catch(() => undefined),
    {
      refreshDeps: [url],
    }
  );

  useEffect(() => {});

  return (
    <>
      {url && (
        <Select disabled={loading} {...selectProps} showSearch allowClear>
          {optionsData?.map((option) => (
            <Select.Option disabled={loading} value={useId ? option.id : option.name}>
              {option.name}
            </Select.Option>
          ))}
          {addOtherOption && <Select.Option value="OTHER">Otro</Select.Option>}
        </Select>
      )}
      {!url && <Select {...selectProps}>{children}</Select>}
    </>
  );
};

SelectWithRequest.propTypes = {
  url: PropTypes.string,
  children: PropTypes.element,
  selectProps: PropTypes.shape(),
  addOtherOption: PropTypes.bool,
  useId: PropTypes.bool,
};

SelectWithRequest.defaultProps = {
  url: undefined,
  children: undefined,
  selectProps: {},
  addOtherOption: undefined,
  useId: false,
};

export default SelectWithRequest;
